import { Selector } from './selector'

export type { SelectorProps, SelectorOption } from './selector'

export default Selector;
